// TaxYearContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const TaxYearContext = createContext();

export const TaxYearProvider = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    // Get current year for the year selector range
    const currentYear = new Date().getFullYear();
    // Default to previous tax year (current year - 1)
    const defaultYear = (currentYear - 1).toString();
    // Generate year options from 2022 to current year
    const yearOptions = Array.from(
        { length: currentYear - 2021 },
        (_, i) => (2022 + i).toString()
    );


    const [taxYear, setTaxYear] = useState(() => {
        // First check URL params
        const urlYear = searchParams.get('year');
        if (urlYear) return urlYear;

        // Then check localStorage
        const storedYear = localStorage.getItem('taxYear');
        if (storedYear) return storedYear;

        // Finally fall back to default
        return defaultYear;
    });

    const updateTaxYear = (newYear) => {
        // Update URL
        setSearchParams(
            prev => {
                const newParams = new URLSearchParams(prev);
                newParams.set('year', newYear);
                return newParams;
            },
            { replace: true }
        );

        // Update localStorage
        localStorage.setItem('taxYear', newYear);

        // Update context state
        setTaxYear(newYear);
    };

    return (
        <TaxYearContext.Provider value={{ taxYear, updateTaxYear, yearOptions }}>
            {children}
        </TaxYearContext.Provider>
    );
};

// Custom hook for using the tax year context
export const useTaxYear = () => {
    const context = useContext(TaxYearContext);
    if (context === undefined) {
        throw new Error('useTaxYear must be used within a TaxYearProvider');
    }
    return context;
};
